import { useEffect, useState, useCallback } from 'react';
import { presetsApi } from '../../api/presets';

export function useQueryPresets(_perPage?: number) {
  const [loading, setLoading] = useState(true);
  const [items, setItems] = useState<any[]>([]);

  const refetch = useCallback(() => {
    setLoading(true);
    return presetsApi
      .list()
      .then((res) => setItems(res.data.nodes))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refetch();
  }, [refetch]);

  const pagination = { totalNodes: items.length, nextPage: null };

  const refetchItems = async () => {
    await refetch();
    return { items, pagination, loading: false };
  };

  return {
    items,
    loading,
    refetch,
    refetchItems,
    pagination,
    onScroll: refetch,
  };
}
